<template>
    <div class="land-contacts" v-if="contactsSetup != null && salesCard != null && setup != null">
        <div class="container">
            <div class="land-section-title" v-if="salesCardPage != null">
                <h2>{{salesCardPage.land_site_section_titles.contacts}}</h2>
            </div>
            <!-- CITY FILTER -->
            <div class="contacts-city-filter" id="sales-land-contacts-city-filter">
                <ul>
                    <li v-for="(item, index) in setup.regions_name" :key="index" v-if="item.city_init_con == 'true' && item.region != 'Санкт-Петербург' && getRulesContactsCity(item.region_lat.slug)"> 
                        <a href="#" @click.prevent="filterCards(item.region_lat.slug)" :class="{active : cityActive === item.region_lat.slug}">{{item.region}}</a>
                    </li>
                </ul>
                <div class="swiper-controls sales-land-contacts-controls" v-if="officeCards != null && officeCards.length > 3">
                    <div class="contacts-btn-prev slider-btn" @click="prevSlide">
                        <svg-icon icon-class="left-arrow" className="icon icon-arrow-left"/>
                    </div>
                    <div class="contacts-btn-next slider-btn" @click="nextSlide">
                        <svg-icon icon-class="right-arrow" className="icon icon-arrow-right"/>
                    </div>
                </div>
            </div>
            <!-- END CITY FILTER -->
            <!-- CONTACTS CARDS ITEMS -->
            <div class="contacts-office-items" id="sales-land-office-items">
                <swiper :options="swiperOptionContacts" ref="saleLandCOntactsCarousel">
                    <swiper-slide v-for="(item, index) in officeCards" :key="index">
                        <div class="office-item">
                            <div class="office-info office-adres">
                                <svg-icon icon-class="pin" className="svg-icon icon-pin"/>
                                <div class="info">
                                    <strong>{{item.office_name}}</strong>
                                    <p><span v-for="desc in item.adres">{{desc.desc}}</span></p>
                                </div>
                            </div>
                            <div class="office-info office-phone">
                                <svg-icon icon-class="mobile" className="svg-icon icon-mobile"/>
                                <div class="info">
                                    <strong>{{contactsSetup.syntax.phone_title}}</strong>
                                    <p><a :href="'tel:' + item.phone_number">{{item.phone_number}}</a></p>
                                </div>
                            </div>
                            <div class="office-info office-time">
                                <svg-icon icon-class="clock" className="svg-icon icon-clock"/>
                                <div class="info">
                                    <strong>{{contactsSetup.syntax.work_time}}</strong>
                                    <p v-for="desc in item.work_time">{{desc.day}}<span class="red">{{desc.time}}</span></p>
                                </div>
                            </div>
                            <div class="show-office-on-map">
                                <a href="#" 
                                    v-scroll-to="{
                                        el: '#contacts-city-filter',
                                        offset: -20
                                    }"
                                    @click="setPinMapCoords(Number(item.office_map_lat), Number(item.office_map_lng))"
                                >
                                    <svg-icon icon-class="click" className="icon-click"/>
                                    <span>{{contactsSetup.syntax.show_map}}</span>
                                </a>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
            <!-- END CONTACTS CARDS ITEMS -->
        </div>
        <!-- CONTACTS SALES MAP -->
        <div class="sales-land-map-container" id="sales-land-map-container">
            <div class="map" id='YmapContactsLand'></div>
        </div>
        <!-- END CONTACTS SALES MAP -->
        <!-- MOBILE -->
        <div class="contacts-office-items contacts-office-items-mobile" id="sales-land-office-items-mobile">
            <div class="office-item" v-for="(item, index) in officeCards" :key="index">
                <div class="office-info office-adres">
                    <svg-icon icon-class="pin" className="svg-icon icon-pin"/>
                    <div class="info">
                        <strong>{{item.office_name}}</strong>
                        <p><span v-for="desc in item.adres">{{desc.desc}}</span></p>
                    </div>
                </div>
                <div class="office-info office-phone">
                    <svg-icon icon-class="mobile" className="svg-icon icon-mobile"/>
                    <div class="info">
                        <strong>{{contactsSetup.syntax.phone_title}}</strong>
                        <p><a :href="'tel:' + item.phone_number">{{item.phone_number}}</a></p>
                    </div>
                </div>
                <div class="office-info office-time">
                    <svg-icon icon-class="clock" className="svg-icon icon-clock"/>
                    <div class="info">
                        <strong>{{contactsSetup.syntax.work_time}}</strong>
                        <p v-for="desc in item.work_time">{{desc.day}}<span class="red">{{desc.time}}</span></p>
                    </div>
                </div>
                <div class="show-office-on-map">
                    <a href="#" 
                        v-scroll-to="{
                            el: '#contacts-city-filter',
                            offset: -20
                        }"
                        @click="setPinMapCoords(Number(item.office_map_lat), Number(item.office_map_lng))"
                    >
                        <svg-icon icon-class="click" className="icon-click"/>
                        <span>{{contactsSetup.syntax.show_map}}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    // import PROMOpage from '@/components/sales/sales-promo-page.vue'
    export default {
        name: 'sale-land-contacts',
        components: {
        },
        data () {
            return {
                mainURL: window.host,
                cityActive: '',
                officeCards: null,
                zoom: 12,
                markerLat: null,
                markerLng: null,
                animateMap: true,
                itemsFilter: [],
                swiperOptionContacts: {
                    speed: 800,
                    observer: true,
                    observeParents: true,
                    // effect: 'fade',
                    slidesPerView: 3,
                    spaceBetween: 74,
                    slidesPerGroup: 3,
                    simulateTouch: false,
                    watchSlidesVisibility: true,
                    lazy: {
                        loadPrevNext: true,
                        loadOnTransitionStart: true
                    },
                },
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            contactsSetup: 'loadContactsPage',
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            mapCoords: 'loadContactsMapCoords',
            pinCoords: 'loadPinCoords',
            cityProject: 'loadCurCity',
        }),
        methods: {
            filterCards(city) {
                this.cityActive = city;
                var data = this.itemsFilter;
                var filteredItems = data.filter(item => {
                    return item.city.slug == city
                });
                var dataCity = this.setup.regions_name;
                var filteredCity = dataCity.filter(item => {
                    return item.region_lat.slug == city
                });
                this.$store.commit('filterContactsMapCoords', filteredCity);
                this.officeCards = filteredItems;
            },
            filterItemsBySettings() {
                var dataTest = this.contactsSetup.office_card;
                for (var i=0; i < dataTest.length; i++) {
                    if (dataTest[i].shablon_init != false) {
                        var filteredTest = dataTest[i].shablon_init.filter(item => {
                            return item.slug == this.mainURL;
                        });
                        // console.log(filteredTest, this.mainURL)
                        if (filteredTest.length > 0) {
                            this.itemsFilter.push(dataTest[i]);
                            // console.log(itemsTest, 'ARRAY TEST')
                        }
                    }
                }
            },
            getRulesContactsCity(city) {
                var data = this.itemsFilter;
                var filteredCity = data.filter(item => {
                    return item.city.slug == city
                });
                if (filteredCity.length > 0) {
                    return true
                } else {
                    return false
                }
            },
            setPinMapCoords(lat, lng) {
                var data = {
                    lat: lat,
                    lng: lng,
                }
                this.$store.commit('setContactsPinCoords', data);
            },
            initFilterCityByPageLoad() {
                // console.log('test', this.cityProject, this.contactsSetup, this.setup);
                // if (this.cityProject != null) {
                var filterCity = this.setup.regions_name.find(x => x.region_lat.slug == this.cityProject.slug);
                // console.log('city init', this.cityProject, filterCity)
                if (filterCity.city_init_con == 'true') {
                    this.filterItemsBySettings();
                    this.filterCards(this.cityProject.slug);
                } else {
                    this.filterItemsBySettings();
                    this.filterCards('almaty');
                }
                // }
            },
            initMapContacts() {
                const _self = this;
                this.$loadScript("https://api-maps.yandex.ru/2.1.75/?apikey=5ec4cf69-f505-4a8a-8b6d-70d1e6402870&lang=ru_RU")
                .then(() => {
                    // if (this.cityProject != null && this.contactsSetup != null) {
                    var location = this.cityProject;
                    var marker = this.contactsSetup.map_marker;
                    var zoom = this.zoom;
                    var links = $('#sales-land-office-items .office-item');
                    var Ymap;
                    var myPlacemark;
                    var i;
                    ymaps.ready().then(function() {
                        
                        var initMap = function() {
                            Ymap = new ymaps.Map('YmapContactsLand', {
                                center: [_self.mapCoords[0].city_map_lng, _self.mapCoords[0].city_map_lat],
                                zoom: zoom,
                                controls: ['fullscreenControl'],
                                behaviors: ["drag", "rightMouseButtonMagnifier", "multiTouch"]
                            },{suppressMapOpenBlock: true, minZoom: 12, maxZoom: 18});
                            Ymap.controls.add('zoomControl', {position: {left: '10px', top: '180px'}});
                        };

                        var buildPinsOnMap = function() {
                            for (i = 0; i < _self.officeCards.length; i++) {
                                var lat = _self.officeCards[i].office_map_lat,
                                    lng = _self.officeCards[i].office_map_lng;
                                myPlacemark = new ymaps.Placemark([lng,lat], {}, {
                                    iconLayout: 'default#image',
                                    iconImageHref: marker,
                                    iconImageSize: [80, 90],
                                    iconImageOffset: [-20, -50]
                                })

                                Ymap.geoObjects.add(myPlacemark);
                            }

                            if (_self.officeCards.length == 1) {
                                Ymap.setCenter([_self.officeCards[0].office_map_lng, _self.officeCards[0].office_map_lat]);
                            }
                        };

                        var destroyMap = function() {
                            Ymap.destroy();
                        };

                        var updateMap = function() {
                            destroyMap();
                            initMap();
                            buildPinsOnMap();
                        };

                        var clicker = function() {
                            $('#sales-land-contacts-city-filter a').on('click', function() {
                                setTimeout(() => {
                                    updateMap();
                                    $('#sales-land-contacts-city-filter a').each(function(i, elem) {
                                        $(elem).on('click', function() {
                                            // _self.animateMap = false;
                                            setTimeout(() => {
                                                updateMap();
                                                setTimeout(() => {
                                                    // _self.animateMap = true;
                                                }, 250);
                                            }, 350);
                                        })
                                    })
                                }, 350);
                            });
                        };

                        _self.$store.watch(
                            (state) => state.pinCoords.lat,
                            (newValue) => {
                                if (newValue) {
                                    // console.log(newValue, 'PIN COORDS')
                                    Ymap.panTo([_self.pinCoords.lng, _self.pinCoords.lat], {
                                        safe: false,
                                        smooth: true,
                                        flying: false,
                                        duration: 600,
                                    })
                                    .then(function() {
                                        Ymap.setZoom(17, { 
                                            smooth: true
                                        })
                                    })
                                }
                            }
                        );

                        initMap();
                        buildPinsOnMap();
                        clicker();
                    });
                })
            },
            prevSlide() {
                this.$refs.saleLandCOntactsCarousel.swiper.slidePrev();
            },
            nextSlide() {
                this.$refs.saleLandCOntactsCarousel.swiper.slideNext();
            }

        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.initFilterCityByPageLoad();
            this.initMapContacts();
            this.$store.watch(
                (state) => state.salesCardContent,
                (newValue) => {
                    console.log(newValue, 'promo test');
                    this.initFilterCityByPageLoad();
                    this.initMapContacts();
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-contacts.scss';
     @import '@/styles/respond/sales/sales-land-partials/land-contacts-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>